import * as appActions from './app/actions'
import * as sessionActions from './session/actions'

const actions = {
    ...appActions,
    ...sessionActions,
}

export default actions
